import { useMediaQuery } from 'react-responsive';

export default function useResponsiveQuery(maxWidth = 767) {
  return useMediaQuery({ query: `(max-width: ${maxWidth}px)` });
}
